// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5147":"f1364e28","5648":"d22b8fc6","6751":"36a2e2a9","8138":"cc99917c"}[chunkId] + ".chunk.css";
};